module.exports = __webpack_public_path__ + "static/media/EXCHANGE-PAGE-SERVICES.cc5e748b.png";